var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16434 22.4587C4.52849 12.3992 12.5158 3.36269 22.7 3.75087L23.2726 3.77269C32.6122 4.12867 40 11.8034 40 21.1498V28.1523C40 32.4865 36.4865 36 32.1523 36H22.0856C14.1764 36 7.43385 30.2654 6.16434 22.4587Z",
    fill: "url(#paint0_linear_16250_289452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16434 22.4587C4.52849 12.3992 12.5158 3.36269 22.7 3.75087L23.2726 3.77269C32.6122 4.12867 40 11.8034 40 21.1498V28.1523C40 32.4865 36.4865 36 32.1523 36H22.0856C14.1764 36 7.43385 30.2654 6.16434 22.4587Z",
    fill: "url(#paint1_linear_16250_289452)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16250_289452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 20.5094C42 30.7215 33.9411 39 24 39C14.0589 39 6 30.7215 6 20.5094C6 10.2974 14.0589 4 24 4C33.9411 4 42 10.2974 42 20.5094Z",
    fill: "url(#paint2_linear_16250_289452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 20.5094C42 30.7215 33.9411 39 24 39C14.0589 39 6 30.7215 6 20.5094C6 10.2974 14.0589 4 24 4C33.9411 4 42 10.2974 42 20.5094Z",
    fill: "url(#paint3_radial_16250_289452)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 26.3208C44 33.3233 38.4036 39 31.5 39C24.5964 39 19 33.3233 19 26.3208C19 19.3182 24.5964 15 31.5 15C38.4036 15 44 19.3182 44 26.3208Z",
    fill: "#AC76F3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6568 38.8888C27.6976 41.0261 21.3453 40.2566 14.4685 37.1702C7.59181 34.0838 2.79472 29.8493 3.75395 27.712C4.71317 25.5748 10.8794 26.7588 17.7561 29.8452C24.6328 32.9316 29.616 36.7516 28.6568 38.8888Z",
    fill: "#432D9D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1248 20.8625C39.6063 22.6463 38.852 14.0939 33.1124 9.20796C27.3729 4.32198 18.8215 4.95257 20.3401 3.16876C21.8586 1.38495 30.4266 1.87903 36.1661 6.76501C41.9056 11.651 42.6433 19.0787 41.1248 20.8625Z",
    fill: "#BEC7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87184 24.2633C7.92177 22.1692 10.6914 30.2957 17.4296 33.6739C24.1677 37.0522 32.3228 34.4029 31.2728 36.497C30.2229 38.5912 21.7839 40.1522 15.0457 36.7739C8.30756 33.3957 5.8219 26.3575 6.87184 24.2633Z",
    fill: "#BEC7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6587,
    cy: 23.3184,
    rx: 4.14254,
    ry: 2.36717,
    transform: "rotate(-11 31.6587 23.3184)",
    fill: "#A791FF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_16250_289452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2602,
    cy: 23.3117,
    rx: 4.14254,
    ry: 2.36717,
    transform: "rotate(-169 16.2602 23.3117)",
    fill: "#A791FF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_16250_289452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 2,
    height: 4,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_16250_289452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 16,
    width: 2,
    height: 4,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_di_16250_289452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2023 22.3553C20.5208 21.9471 21.1017 21.8809 21.4997 22.2075C22.9615 23.4066 25.0385 23.4066 26.5003 22.2075C26.8983 21.8809 27.4792 21.9471 27.7977 22.3553C28.1162 22.7635 28.0516 23.3592 27.6535 23.6858C25.5175 25.4381 22.4824 25.4381 20.3465 23.6858C19.9484 23.3592 19.8838 22.7635 20.2023 22.3553Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_16250_289452",
    x: 0.949219,
    y: 0.739258,
    width: 42.0508,
    height: 38.2607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16250_289452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654402 0 0 0 0 0.62822 0 0 0 0 0.942399 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_16250_289452",
    result: "effect2_dropShadow_16250_289452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_16250_289452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_16250_289452",
    x: 4,
    y: 0,
    width: 55,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_16250_289452",
    x: -11.3672,
    y: 11.6279,
    width: 55.1406,
    height: 43.4707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_16250_289452",
    x: 12.1641,
    y: -5.77734,
    width: 37.6445,
    height: 34.8809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_16250_289452",
    x: -1.35938,
    y: 15.9229,
    width: 40.7227,
    height: 30.8203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_16250_289452",
    x: 24.5664,
    y: 17.8633,
    width: 14.1836,
    height: 10.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_16250_289452",
    x: 9.16797,
    y: 17.8564,
    width: 14.1836,
    height: 10.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_16250_289452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_16250_289452",
    x: 15,
    y: 14,
    width: 6,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16250_289452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16250_289452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_16250_289452",
    x: 27,
    y: 14,
    width: 6,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16250_289452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16250_289452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_di_16250_289452",
    x: 18,
    y: 20,
    width: 12,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16250_289452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16250_289452",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.693381 0 0 0 0 0.688184 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16250_289452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16250_289452",
    x1: 13.3092,
    y1: 9.34615,
    x2: 37.495,
    y2: 33.5656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838AEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#A88DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3E89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16250_289452",
    x1: 40,
    y1: 16.2564,
    x2: 40,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9691E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16250_289452",
    x1: 24,
    y1: 2.01887,
    x2: 24,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD78FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16250_289452",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.24138 23.0599) rotate(-2.63355) scale(41.6302 42.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FDAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F41C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16250_289452"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi);
export default __webpack_public_path__ + "static/media/hi.dfa9bc51e335208f3d1c69205814029d.svg";
export { ForwardRef as ReactComponent };